/**
 * Function to resolve a link in WP content
 *
 * IMPORTANT:
 * Expected Settings in WP > Settings > Permalinks
 * - Custom Structure: /posts/%postname%/
**/

import { isRelLink, isExtLink } from '@/utils'

export default function (href) {
  let base = process.env.BASE_URL || ''
  base = base.replace(/\/$/g, '') // remove ending /
  // no href (WP draft previews)
  if (!href) return ''
  // relative
  if (isRelLink(href) || isExtLink(href)) return href
  const url = new URL(href)
  // home ?
  if (url.pathname === '/') return base + '/'
  // parse path
  else {
    let path = url.pathname + url.search
    path = path.split('/')
    // home ?
    if (path[1] === 'home') return base + '/'
    // wps_collections
    if (path[1] === 'collections') return '/hostem/' + path[2]
    // post types
    else if (path[1] === 'posts') {
      // remove "posts" from path (see instructions above)
      path.splice(1, 1)
      // custom posts
      if (['blue-projects'].includes(path[1])) {
        return base + path.join('/')
      }
      // posts (articles)
      return base + '/library' + path.join('/')
    }
    // default (page)
    return base + path.join('/')
  }
}
